import { render } from "./EditMedicationDialog.vue?vue&type=template&id=205f674c"
import script from "./EditMedicationDialog.vue?vue&type=script&lang=js"
export * from "./EditMedicationDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__